import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';
import { Paragraph } from '@va/ui/design-system';
import { useMemo } from 'react';

export const PendingSenderEmailCancelationConfirmationModel: React.FC<ConfirmationDialogProps> = ({
  onClose,
  onConfirm,
}) => {
  const translate = useTranslate();

  const infoNode = useMemo(() => {
    return (
      <div>
        <Paragraph>{translate('customSenderEmail.confirmCancel.line1')}</Paragraph>
      </div>
    );
  }, [translate]);

  return (
    <ConfirmationModal
      info={infoNode}
      title={translate('customSenderEmail.confirmCancel.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};
